import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ProfileConsents } from '../model/share-data.types';

@Injectable({ providedIn: 'root' })
export class ShareDataService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.url.api}/profile/me`;

  linkExistingBrands(consents: ProfileConsents): Observable<void> {
    return this.http.post<void>(`${this.url}/link`, { consents });
  }

  setupBrandProfile(consents: ProfileConsents): Observable<void> {
    return this.http.post<void>(`${this.url}/setup`, consents);
  }
}
